import { Component, input } from '@angular/core';

/** Main logo. */
@Component({
	selector: 'protctw-main-logo',
	templateUrl: './main-logo.component.html',
	styleUrls: ['./main-logo.component.css'],
})
export class MainLogoComponent {
	/** Logo src. */
	public readonly logo = input('');
}
